import { isTechnicalAuditIdentifier } from '@/lib/auditLogLabels';

export function formatPersonName(
  first?: string | null,
  last?: string | null,
): string | null {
  const parts = [first, last]
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part));
  return parts.length > 0 ? parts.join(' ') : null;
}

export function isMissingActorEmail(email: string | null | undefined): boolean {
  if (!email) return true;
  return email.trim().toLowerCase() === 'system';
}

export type AuditPeopleLog = {
  actor_id: string | null;
  actor_email: string | null;
  actor_name?: string | null;
  target_type: string;
  target_id: string | null;
  target_identifier: string | null;
};

export type AuditActorLookup = {
  name: string | null;
  email: string | null;
};

export function enrichAuditLogPeople<T extends AuditPeopleLog>(
  logs: T[],
  patients: Map<string, string>,
  users: Map<string, AuditActorLookup>,
): T[] {
  return logs.map((log) => {
    let target_identifier = log.target_identifier;
    if (
      log.target_type === 'patient' &&
      log.target_id &&
      isTechnicalAuditIdentifier(target_identifier)
    ) {
      target_identifier = patients.get(log.target_id) ?? null;
    }

    const user = log.actor_id ? users.get(log.actor_id) : undefined;
    const actor_name = user?.name?.trim() || log.actor_name?.trim() || null;
    let actor_email = log.actor_email;
    if (isMissingActorEmail(actor_email) && user?.email) {
      actor_email = user.email;
    }

    return { ...log, target_identifier, actor_name, actor_email };
  });
}
